<template>
  <div class="event-table">
    <el-table
      :data="invitationArray"
      style="width: 100%"
      empty-text="No invitations"
    >
      <el-table-column prop="name" label="Users" :width="300">
        <template #default="scope">
          <div>
            <router-link
              v-if="scope.row.link"
              :to="{
                name: 'UserProfile',
                params: { link: scope.row.link },
              }"
            >
              <div class="event-table__user">
                <el-avatar class="event-table__avatar" :size="50">
                  <user-avatar :userId="scope.row.userId" :alt="scope.row.name" />
                </el-avatar>
                <span class="event-table__name">
                  {{ scope.row.name }}
                </span>
              </div>
            </router-link>

            <div v-else class="event-table__user">
              <el-avatar class="event-table__avatar" :size="50">
                <user-avatar :userId="scope.row.userId" :alt="scope.row.name" />
              </el-avatar>
              <span class="event-table__name dash-if-empty">
                {{ scope.row.name }}
              </span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="comments" label="Comment">
        <template #default="scope">
          <div class="dash-if-empty event-table__comment">
            {{ scope.row.comments }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="Status" :width="120">
        <template #default="scope">
          <div>
            {{ scope.row.role }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" :width="200">
        <template #default="scope">
          <el-button
            type="danger"
            plain
            @click="requestCancelInvitation(scope.row)"
            :disabled="isButtonDisabled('cancel-invitation')"
          >
            Cancel invitation
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { removeTeamInvitation, getTeamInvitations } from '@/api/team.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';
import UserAvatar from '../profile/UserAvatar.vue';

export default {
  name: 'TeamInvitations',
  props: {
    teamId: {
      type: Number,
      required: true,
    },
  },
  mixins: [disableButton],
  data() {
    return {
      invitationArray: [],
    };
  },
  components: {
    UserAvatar,
  },
  methods: {
    showMessage,
    async fetchInvitations() {
      const { teamId } = this;
      const { data, success } = await getTeamInvitations({ teamId });

      if (success) {
        this.setData(data.items);
      }
    },
    async requestCancelInvitation({ teammateId }) {
      this.disableButton('cancel-invitation');
      const { success } = await removeTeamInvitation({ teammateId });
      this.enableButton('cancel-invitation');

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Invitation has been canceled',
        });
        this.fetchInvitations();
      }
    },
    setData(data) {
      this.invitationArray = data.map((invitation) => {
        return {
          teammateId: invitation.teammateId,
          name: invitation.user
            ? invitation.user.firstName + ' ' + invitation.user.lastName
            : '',
          link: invitation.user ? invitation.user.link : null,
          role: invitation.role,
          userId: invitation.user ? invitation.user.userId : null
        };
      });
    },
  },
  created() {
    this.fetchInvitations();
  },
};
</script>
